module.exports = __webpack_public_path__ + "img/oneRed.7a4134d9.jpg";